import { SystemStyleObject } from "@chakra-ui/react";

export const paginationWrapperCss: SystemStyleObject = {
  fontSize: "12px",
  color: "#807F94",

  "& > [data-scope='pagination']": {
    color: "#807F94",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
  },
  "& > [data-scope='pagination'] > [data-selected]": {
    backgroundColor: "#EEEEF1",
    color: "#09090B",
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    padding: "8px",
  },
  "& > [data-selected]:hover": {
    backgroundColor: "#EEEEF1",
    color: "#09090B",
  },
};
